var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgBothDirections = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14.996,
    height: 11.12,
    viewBox: "0 0 14.996 11.12",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .both-svg-1,.both-svg-2{fill:none;stroke:#5167fd;stroke-linecap:round}.both-svg-2{stroke-linejoin:round}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1189",
    "data-name": "Group 1189",
    transform: "translate(-.246 -.818)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1187",
    "data-name": "Group 1187",
    transform: "translate(0 -.04)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20795",
    "data-name": "Path 20795",
    className: "both-svg-1",
    d: "M0 0h7.38",
    transform: "translate(6.361 7.727)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20798",
    "data-name": "Path 20798",
    className: "both-svg-1",
    d: "M7.38 0H0",
    transform: "translate(3.361 5.383)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20796",
    "data-name": "Path 20796",
    className: "both-svg-2",
    d: "m-18421.824-3850.792 2.414-2.415-2.414-2.414",
    transform: "translate(18434.152 3861.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20799",
    "data-name": "Path 20799",
    className: "both-svg-2",
    d: "m-18419.41-3850.792-2.414-2.415 2.414-2.414",
    transform: "translate(18424.186 3858.588)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_20797",
    "data-name": "Path 20797",
    d: "M-18424.475-3852.9v-1.914h-7.2v10.12h7.2v-1.792",
    transform: "translate(18432.418 3856.13)",
    style: {
      strokeLinejoin: "round",
      fill: "none",
      stroke: "#5167fd"
    }
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBothDirections, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/BothDirections.7a75206c.svg";
export { ForwardRef as ReactComponent };